import { useSelector } from 'react-redux';
import {
  baseURLSelector,
  languageSelector,
} from '../redux/reducers/app/params';
import { getLobbyURL } from '../utils';

export const useLobbyURL = () => {
  const baseURL = useSelector(baseURLSelector);
  const language = useSelector(languageSelector);

  return getLobbyURL(baseURL, language);
};
